import { classnames } from '@/libs/utils';

const SkeletonPulse = ({ classname = '' }: { classname?: string }) => {
  return <div className={classnames('animate-pulse bg-slate-300', classname)} />;
};
export default SkeletonPulse;
